import { render, staticRenderFns } from "./SetupCompanyPayment.vue?vue&type=template&id=01db16ec&scoped=true"
import script from "./SetupCompanyPayment.vue?vue&type=script&lang=js"
export * from "./SetupCompanyPayment.vue?vue&type=script&lang=js"
import style0 from "./SetupCompanyPayment.vue?vue&type=style&index=0&id=01db16ec&prod&lang=scss"
import style1 from "./SetupCompanyPayment.vue?vue&type=style&index=1&id=01db16ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01db16ec",
  null
  
)

export default component.exports